module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/attachmentpoints/attachmentpoints-delete/attachmentpoints-delete.component.css
// module id = ./src/app/attachmentpoints/attachmentpoints-delete/attachmentpoints-delete.component.css
// module chunks = main